import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return (
        <svg {...validProps} viewBox={'0 0 88 88'}>
            <g className='background-fill'>
                <path d='M44,0C19.7,0,0,19.7,0,44s19.7,44,44,44s44-19.7,44-44S68.3,0,44,0z M68.3,33.7L38.2,63.4c-0.4,0.4-1,0.4-1.4,0l-17-16.7 c-0.4-0.4-0.4-1,0-1.4l7.8-7.7c0.4-0.4,1-0.4,1.4,0l7.8,7.7c0.4,0.4,1,0.4,1.4,0L59,24.6c0.2-0.2,0.4-0.3,0.8-0.3 c0.3,0,0.5,0.1,0.7,0.3l7.8,7.7C68.7,32.7,68.7,33.3,68.3,33.7z' />
            </g>
            <g className='outline'>
                <path
                    d='M44,4c22.1,0,40,17.9,40,40S66.1,84,44,84S4,66.1,4,44S21.9,4,44,4 M44,0C19.7,0,0,19.7,0,44s19.7,44,44,44s44-19.7,44-44
                    S68.3,0,44,0z'
                />
                <path d='M59.8,24.3c0.3,0,0.5,0.1,0.7,0.3l7.8,7.7c0.4,0.4,0.4,1,0,1.4L38.2,63.4c-0.4,0.4-1,0.4-1.4,0c0,0,0,0,0,0l-17-16.7 c-0.4-0.4-0.4-1,0-1.4l7.8-7.7c0.4-0.4,1-0.4,1.4,0c0,0,0,0,0,0l7.8,7.7c0.4,0.4,1,0.4,1.4,0c0,0,0,0,0,0L59,24.6 C59.2,24.4,59.4,24.3,59.8,24.3 M59.7,20.3c-1.3,0-2.6,0.5-3.5,1.4L37.4,40.3l-5.7-5.6c-1.9-1.9-5.1-1.9-7,0L17,42.4 c-2,1.9-2,5.1,0,7.1c0,0,0,0,0,0l17,16.7c1.9,1.9,5.1,1.9,7,0l30-29.7c2-1.9,2-5.1,0-7.1c0,0,0,0,0,0l-7.8-7.7 C62.3,20.8,61,20.3,59.7,20.3z' />
            </g>
        </svg>
    );
}
SvgComponent.iconName = 'joyride-task-management';

export const JoyrideTaskManagementIcon = svgIconWrapper(SvgComponent);
